import { Dialog, DialogContent, Divider, IconButton } from '@mui/material';
import i18n from '../../../../../utils/i18n';
import CustomButton from '../../../../components/CustomButton';
import SubscriptionRowInfo from './SubscriptionRowInfo';

const PackageInfoMarketing = ({
	openMarketingInfo,
	setOpenMarketingInfo,
	title,
	subTitle,
	onConfirm,
}) => {
	const handleCloseMarketingInfo = () => {
		setOpenMarketingInfo(false);
	};

	return (
		<Dialog
			open={openMarketingInfo}
			onClose={handleCloseMarketingInfo}
			PaperProps={{
				sx: {
					width: '420px',
					height: 'auto',
					maxWidth: 'none',
					borderRadius: '18px',
					overflow: 'hidden',
				},
			}}
			sx={{
				'& .MuiDialog-container': {
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				},
				'& .MuiDialog-paper': {
					width: '420px',
					maxWidth: 'none',
				},
			}}>
			<IconButton
				aria-label='close'
				onClick={handleCloseMarketingInfo}
				sx={{
					position: 'absolute',
					top: '8px',
					right: '8px',
					color: '#ffffff',
					padding: '8px',
					userSelect: 'none',
					backgroundColor: 'transparent',
					outline: 'none',
					'&:focus': { outline: 'none' },
					'&:active': { backgroundColor: 'transparent' },
				}}></IconButton>

			<DialogContent
				sx={{
					padding: '18px',
					height: 'auto',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'flex-start',
					overflowY: 'auto',
					scrollbarWidth: 'thin', // Firefox support
					scrollbarColor: '#8791b4 #f1f1f1', // Firefox support

					/* Scrollbar Webkit (Chrome, Safari, Edge) */
					'&::-webkit-scrollbar': {
						width: '10px',
						backgroundColor: '#f1f1f1',
					},
					'&::-webkit-scrollbar-track': {
						backgroundColor: '#e0e0ff',
						borderRadius: '10px',
					},
					'&::-webkit-scrollbar-thumb': {
						backgroundColor: '#8791b4',
						borderRadius: '10px',
						border: '2px solid #e0e0ff',
					},
					'&::-webkit-scrollbar-thumb:hover': {
						backgroundColor: '#6c7493',
					},
				}}>
				<div style={{ width: '100%' }}>
					<div
						style={{
							fontSize: '16px',
							fontWeight: '700',
							color: '#0b0f31',
							margin: '4px 0',
							padding: '18px 18px 0px 18px',
						}}>
						{title}
					</div>
					<div
						style={{
							fontSize: '14px',
							fontWeight: '500',
							color: '#4b5080',
							margin: '4px 0',
							padding: '18px',
						}}>
						{subTitle}
					</div>

					<div>
						<Divider sx={{ margin: '0 18px' }} />
						<SubscriptionRowInfo
							title={i18n.t('provider.subscriptionrow1')}
							tick1={true}
						/>
						<Divider sx={{ margin: '0 18px' }} />
						<SubscriptionRowInfo
							title={i18n.t('provider.subscriptionrow2')}
							tick1={true}
						/>
						<Divider sx={{ margin: '0 18px' }} />
						<SubscriptionRowInfo
							title={i18n.t('provider.subscriptionrow3')}
							tick1={true}
						/>
						<Divider sx={{ margin: '0 18px' }} />
						<SubscriptionRowInfo
							title={i18n.t('provider.subscriptionrow4')}
							tick1={true}
						/>
						<Divider sx={{ margin: '0 18px' }} />
						<SubscriptionRowInfo
							title={i18n.t('provider.subscriptionrow5')}
							tick1={true}
						/>
						<Divider sx={{ margin: '0 18px' }} />
						<SubscriptionRowInfo
							title={i18n.t('provider.subscriptionrow6')}
							tick1={false}
						/>
					</div>

					<div style={{ margin: '8px 0' }}>
						<CustomButton
							buttonName={i18n.t('provider.subpackagebutton3')}
							onClick={handleCloseMarketingInfo}
							buttonColor='#ffffff'
							hoverColor='#fafcfe'
							titleColor='#4b5080'
							titleHoverColor='#4b5080'
							width='100%'
							height='44px'
							padding='12px'
						/>
					</div>
				</div>
			</DialogContent>
		</Dialog>
	);
};

export default PackageInfoMarketing;
